module.exports = __webpack_public_path__ + "static/media/fhf_logo.dd32f951.png";